<template>
  <v-select
    v-model="status"
    :items="campos"
    clearable
    @click:clear="clearStatus"
    outlined
    dense
    hide-details
    item-text="text"
    item-value="value"
    label="Status"
  ></v-select>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ProdutosAtivos",

  data() {
    return {
      status: null,
      campos: null,
    };
  },

  computed: {
    ...mapState("FiltrosRelatorios", {
      filtros_componente: (state) => state.filtros_componente,
    }),
  },

  watch: {
    status() {
      if (this.status) {
        this.$store.commit("FiltrosRelatorios/UPDATE_PRODUTOS_ATIVOS", this.status);
      }
    },
  },

  methods: {
    clearStatus() {
      this.$store.commit("FiltrosRelatorios/UPDATE_PRODUTOS_ATIVOS", null);
      this.status = null;
    },
  },

  async created() {
    this.filtros_componente.find((item) => {
      if (item.text == "ProdutosAtivos") {
        if (item.default) {
          this.status = item.default;
        }
        return (this.campos = item.options);
      }
    });
  },
};
</script>

<style></style>
